import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ProfileCard from "../../profile/components/ProfileCard";
import { SubDepartments, SubDeptLogoMap } from "../../../../../utils/enums";
import { GetSubDepartmentsByDepartment } from "../../../../../service/repos/users_repo";
import Layout from "../../layout";

interface SubDepartment {
  subDepartment: string;
  count: number;
}

const DepartmentSubList = () => {
  const { dept } = useParams<{ dept: string }>();
  const [subDepartments, setSubDepartments] = useState<SubDepartment[]>([]);

  const getLogo = (dept: string) => {
    const deps = Object.keys(SubDepartments);

    switch (dept) {
      case deps[0]:
        return "accounts";
      case deps[1]:
        return "strategy";
      case deps[2]:
        return "procurement";
      case deps[3]:
        return "hr";
      case deps[4]:
        return "management1";
      case deps[5]:
        return "sales";
      case deps[6]:
        return "content";
      case deps[7]:
        return "operations";
      case deps[8]:
        return "tech";
      case deps[9]:
        return "design";

      default:
        return "nothing";
    }
  };

  const getSubDeptLogo = (dept: string, subDept: string) => {
    return SubDeptLogoMap[subDept] || getLogo(dept);
  };

  useEffect(() => {
    if (!dept) return;
    fetchSubDepartments();
  }, [dept]);

  const fetchSubDepartments = async () => {
    const res = await GetSubDepartmentsByDepartment(dept);
    if (res.success) {
      const checkData = res.data?.filter((d: any) => d.department !== null);

      var count = 0;
      for (let i = 0; i < checkData.length; i++) {
        count = count + checkData[i].count;
      }
      setSubDepartments(res.data);
    }
  };

  return (
    <Layout pageTitle="SubDepartments">
      <div className="py-4 lg:pl-6">
        <h2 className="text-xl font-semibold mb-4">
          {decodeURIComponent(dept)} - Sub Departments
        </h2>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {subDepartments.map((sub, i) => (
            <ProfileCard
              key={i}
              data={{
                ...sub,
                logo: getSubDeptLogo(dept, sub.subDepartment),
                link: `/hrm/employeeList/${encodeURIComponent(
                  dept
                )}/${encodeURIComponent(sub.subDepartment)}`,
                count: sub.count + " people",
                department: sub.subDepartment,
              }}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default DepartmentSubList;
